import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FieldConfigDTO } from '../../../system/system-dtos';
import { DataType } from '../../data-type-widgets/data-type/data-type-component';

@Component({
  selector: 'app-resolve-game-line-action-modal',
  templateUrl: './resolve-game-line-action-modal.component.html',
  styleUrls: ['./resolve-game-line-action-modal.component.scss'],
  standalone: false,
})
export class ResolveGameLineActionModalComponent implements OnInit {
  public formGroup: UntypedFormGroup;
  public selectedFinalResult: string = 'WIN';
  confirmation = false;
  winAmountFieldConfig: FieldConfigDTO = { name: 'winAmount', label: 'Win amount', type: DataType.money };
  nettPriceFieldConfig: FieldConfigDTO = { name: 'nettPrice', label: 'Nett price', type: DataType.money };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ResolveGameLineActionModalComponent>,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      finalResult: ['WIN', Validators.required],
      winAmount: [],
      refundStakeAmount: [false],
    });
  }

  isWin() {
    return this.formGroup.get('finalResult').value == 'WIN';
  }

  isRefund() {
    return this.formGroup.get('refundStakeAmount').value;
  }

  yes() {
    if (!this.confirmation) {
      this.confirmation = true;
    } else {
      this.dialogRef.close(this.formGroup.getRawValue());
    }
  }

  no() {
    this.dialogRef.close(false);
  }
}
